import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { tapi } from './api';
import { campaignAlertsSlice } from './campaignAlerts';
import { campaignsSlice } from './campaigns';
import { popupSlice } from './popup';

export const getStore = (preloadedState: unknown) =>
  configureStore({
    reducer: {
      [tapi.reducerPath]: tapi.reducer,
      campaigns: campaignsSlice.reducer,
      campaignAlerts: campaignAlertsSlice.reducer,
      popup: popupSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: ['popup/setPopupProps', 'popup/updatePopupProps'],
          ignoredPaths: [
            'popup.componentProps.onConfirm',
            'popup.componentProps.onCancel',
          ],
        },
      }).concat(tapi.middleware),
    preloadedState,
  });

export const store = getStore({});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
